export default __webpack_public_path__ + "static/media/ORYX_InformationIcon.c5cdd29b.svg";